import React from "react";
import styles from "./FeaturedPage.module.scss";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import { Link } from "react-router-dom";
import homeIcon from "@/assets/icons/smartphone.svg";
import videoIcon from "@/assets/icons/film.svg";
import musicIcon from "@/assets/icons/music-content.svg";
import Layout from "@/components/Layout/Layout";

const cardData = [
  {
    icon: homeIcon,
    label: "Home",
    link: "/featured-content/home",
  },
  {
    icon: videoIcon,
    label: "Videos",
    link: "/featured-content/video",
  },
  {
    icon: musicIcon,
    label: "Songs",
    link: "/featured-content/songs",
  },
];

const FeaturedPageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  return (
    <Layout admin={admin}>
      <div className={styles.pageCards}>
        {cardData.map((card, index) => (
          <div key={index} className={styles.container}>
            <div className={styles.content}>
              <div className={styles.iconWrap}>
                <img className={styles.icon} src={card.icon} alt={card.label} />
              </div>
              <div className={styles.contentText}>
                <p className={styles.label}>{card.label}</p>
              </div>
            </div>
            <Link to={card.link}>
              <button className={styles.btn}>View</button>
            </Link>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export const FeaturedPage = withAdmin(FeaturedPageCmp);
FeaturedPageCmp.displayName = "FeaturedPageCmp";

